import MDButton from "./MDButton"; // Adjust the import path as needed

const ExportButton = ({ loading, handleExport }) => {
    const handleClick = async () => {
        const Swal = (await import('sweetalert2')).default;
        Swal.fire({
            title: 'Export Format',
            text: 'Choose the export format',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'CSV',
            cancelButtonText: 'XLSX',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                handleExport('csv');
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                handleExport('xlsx');
            }
        });
    };

    return (
        <MDButton
            variant="outlined"
            color="primary"
            size="small"
            loading={loading}
            onClick={handleClick}
        >
            Export
        </MDButton>
    );
};

export default ExportButton;